import React, { type ReactNode } from 'react';
import type { AppManifest } from '@api/apps';
import AppCard from '../AppCard';
import AppActionsMenu, { type AppAction } from './AppActionsMenu';
import { Tile, TileFooter } from './AppTile.styled';

interface AppTileProps {
  readonly appKey: string;
  readonly manifest: AppManifest;
  readonly onOpen: () => void;
  readonly menuLabel: string;
  readonly actions: readonly AppAction[];
  readonly footer?: ReactNode;
}

/** A gallery card with what only user apps carry: a state line and a menu. */
const AppTile: React.FC<AppTileProps> = ({
  appKey,
  manifest,
  onOpen,
  menuLabel,
  actions,
  footer,
}) => (
  <Tile data-testid={`apps-gallery__tile-${appKey}`}>
    <AppCard appKey={appKey} manifest={manifest} onOpen={onOpen} />
    <AppActionsMenu
      ariaLabel={menuLabel}
      actions={actions}
      dataTestId={`apps-gallery__menu-${appKey}`}
    />
    {footer && <TileFooter>{footer}</TileFooter>}
  </Tile>
);

export default AppTile;
